import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useUIContext } from 'state/ui';

import { priceWithoutTax } from '../utils';

import { PriceWithoutTaxStyle } from './price-without-tax.styled';

export interface IPriceWithoutTaxProps {
  totalAmount: number;
}
// This is a temporary fix to achieve https://rbictg.atlassian.net/browse/IREQ-3564
// The RBI platform should NOT be responsible for calculating prices/taxes, this should be done on the POS level

export const PriceWithoutTax: FC<IPriceWithoutTaxProps> = ({ totalAmount }) => {
  const { formatCurrencyForLocale } = useUIContext();
  const { formatMessage } = useIntl();
  const taxPercentage = useFlag(LaunchDarklyFlag.BK_AR_TAX) as unknown as number;
  const withoutTax = formatCurrencyForLocale(priceWithoutTax(totalAmount, taxPercentage));
  return (
    <PriceWithoutTaxStyle>
      {formatMessage(
        { id: 'priceWithoutTax' },
        {
          price: withoutTax,
        }
      )}
    </PriceWithoutTaxStyle>
  );
};
